module.exports = __webpack_public_path__ + "prod/20260929161836/img/experience.942f4ebf.png";